import React, { useContext, useState, useEffect } from "react";
import "./Home.scss";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import GATracker from "../components/GATracker";
import { LoadingContext } from "../../api/loading/LoadingContext";
import ChanelHome from "./../components/ChanelHome";

const LoadingAnimation = require("react-loading-animation");

function Home({ location }) {
  const [data, setData] = useState(null);
  const { loading, dispatchLoading } = useContext(LoadingContext);

  const scrollbarRef = React.createRef();

  useEffect(() => {
    //FETCH HAND DETAILS
    //console.log("home effect");
    dispatchLoading({ type: "update", payload: 10 });
    let url = window.serverUrl+"/social/home.php";
    fetch(url)
      .then((r) => r.json())
      .then((_data) => {
        //console.log("home data", _data);
        dispatchLoading({ type: "update", payload: 50 });
        setData((d) => _data);
        setTimeout(() => {
          dispatchLoading({ type: "update", payload: 100 });
        }, 500);
      })
      .catch((err) => {
        setTimeout(() => {
          dispatchLoading({ type: "update", payload: 100 });
        });
        console.error("fetch problem", err);
      });
    return () => {
      console.log("home done");
    };
  }, [dispatchLoading]);

  return (
    <>
      <GATracker></GATracker>
      <PerfectScrollbar
        className="chanel-scroll main-scroll"
        ref={scrollbarRef}
      >
        <div className="chanel-container home-chanel d-flex flex-column">
          {data !== null && loading.progress === 100 ? (
            <ChanelHome data={data}></ChanelHome>
          ) : (
            <div className="loading-container">
              <LoadingAnimation />
            </div>
          )}
        </div>
      </PerfectScrollbar>
    </>
  );
}
export default Home;
